import axios from '../../axios'
import { IArticleAddParams, IArticleDetailData, IArticleDetailParams, IArticlePageListData, IArticlePageListParams, IArticleUpdateParams } from './inspection_article.types'

// 点检推荐文章


/**
 * 添加
 */
export function articleAdd(params: IArticleAddParams) {
    return axios({
        method: 'post',
        url: '/inspection/article/add',
        data: params
    })
}

/**
 * 删除
 */
export function articleDelete(id: number) {
    return axios({
        method: 'delete',
        url: `/inspection/article/delete/${id}`,
    })
}

/**
 * 
 */
export function articlePageList(params: IArticlePageListParams) {
    return axios<IArticlePageListData>({
        method: 'get',
        url: '/inspection/article/pageList',
        params
    })
}

/**
 * 
 */
export function articleDetail(params: IArticleDetailParams) {
    return axios<IArticleDetailData>({
        method: 'get',
        url: '/inspection/article/getDetail',
        params
    })
}

/**
 * 
 */
export function articleUpdate(params: IArticleUpdateParams) {
    return axios({
        method: 'put',
        url: '/inspection/article/update',
        data: params
    })
}